export default __webpack_public_path__ + "static/media/MedicineBackground.fc017dd7.svg";